import actionTypes from '../constants/action-types';
import SharedApi from '../../../../api/shared-api';

export const getAccountManagerInfo = () => {
  return async dispatch => {
    try {
      const response = await SharedApi.getAccountManagerInfo();
      const data = response && response.data;
      dispatch(handleSuccessGetAccountManagerInfo(data));
    } catch (error) {}
  };
};

export const getNews = () => {
  return async dispatch => {
    try {
      const response = await SharedApi.getNews();
      const data = response && response.data;
      dispatch(handleSuccessGetNews(data));
    } catch (error) {}
  };
};

export const setTabs = tabs => {
  return {
    type: actionTypes.SET_TABS,
    data: tabs,
  };
};

export const handleSuccessGetAccountManagerInfo = data => {
  return {
    type: actionTypes.HANDLE_GET_ACCOUNT_MANAGER_INFO,
    data,
  };
};

export const handleSuccessGetNews = data => {
  return {
    type: actionTypes.HANDLE_GET_NEWS,
    data,
  };
};

export const toggleMenu = show => {
  return {
    type: actionTypes.TOGGLE_MENU,
    data: show,
  };
};

export const handleBlockUnblockUi = uiBlocked => {
  return {
    type: actionTypes.HANDLE_BLOCK_UNBLOCK_UI,
    data: uiBlocked,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/layout/actions/layout-actions.js